var PresentersBase;

PresentersBase = {
  getI18n: function(I18nScope) {
    var scope;
    scope = I18nScope;
    if (scope != null) {
      return I18n.scoped(scope);
    } else {
      return I18n;
    }
  },
  toHashWithHelpers: function(hash, I18nScope) {
    var presenterHash;
    presenterHash = _.clone(hash);
    return I18n.mixin(presenterHash, this.getI18n(I18nScope));
  }
};

module.exports = PresentersBase;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvYmFja2JvbmVfYmFzZS9mcm9udGVuZC9wcmVzZW50ZXJzL2Jhc2UuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvYmFja2JvbmVfYmFzZS9mcm9udGVuZC9wcmVzZW50ZXJzL2Jhc2UuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsY0FBQSxHQUNFO0VBQUEsT0FBQSxFQUFTLFNBQUMsU0FBRDtBQUNQLFFBQUE7SUFBQSxLQUFBLEdBQVE7SUFDUixJQUFHLGFBQUg7YUFDRSxJQUFJLENBQUMsTUFBTCxDQUFZLEtBQVosRUFERjtLQUFBLE1BQUE7YUFHRSxLQUhGOztFQUZPLENBQVQ7RUFPQSxpQkFBQSxFQUFtQixTQUFDLElBQUQsRUFBTyxTQUFQO0FBQ2pCLFFBQUE7SUFBQSxhQUFBLEdBQWdCLENBQUMsQ0FBQyxLQUFGLENBQVEsSUFBUjtXQUNoQixJQUFJLENBQUMsS0FBTCxDQUFXLGFBQVgsRUFBMEIsSUFBQyxDQUFBLE9BQUQsQ0FBUyxTQUFULENBQTFCO0VBRmlCLENBUG5COzs7QUFXRixNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
